import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    grow: { flexGrow: 1 },
    noSelectedConnection: {
        paddingTop: '3rem',
        alignSelf: 'center' as const,
        justifySelf: 'center' as const,
        height: '100%'
    },
    apiIcon: {
        height: '90px',
        width: '90px',
        paddingBottom: '.5rem'
    },
    header: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        flexShrink: 1,
        flexBasis: 'auto',
        padding: '.5rem 1rem'
    },
    gridContainer: { borderTop: '1px solid #cccccc' },
    userDetailsContainer: { padding: '2.5rem 3rem' }
});